import { render, staticRenderFns } from "./AssignEntranceRoom.vue?vue&type=template&id=1123bd5e"
import script from "./AssignEntranceRoom.vue?vue&type=script&lang=js"
export * from "./AssignEntranceRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports